// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2d1n9","head":"ProcedureTableInfo_head__3GpvQ"};